// React Query keys
export const MY_ASSETS_KEY = "me:myAssets";
export const MY_CLEARANCE_KEY = "me:myClearance";

export const ASSIGNMENT_STATUS = {
  ACTIVE: { label: "Active", tone: "blue" },
  RETURNED: { label: "Returned", tone: "gray" },
  LOST: { label: "Lost", tone: "red" },
};

export const ASSET_TABS = [
  { id: "current", label: "Current" },
  { id: "history", label: "History" },
];
